import { Injectable } from '@angular/core';
import { Renderer2, RendererFactory2 } from '@angular/core';


@Injectable()
export class LoaderService {
    private renderer: Renderer2;
    // set this flag when navigating between apps
    // refer : https://basecamp.com/2083367/projects/14588452/messages/92394375
    constructor(
        private rendererFactory: RendererFactory2

    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                this.hideLoader();
                this.hideLoaderFromNotifications();
            }
        });
    }

    hideLoaderFromNotifications() {
        const notificationContainer = document.getElementById('notificationContainer');
        const loader = notificationContainer?.querySelector('#notification-loader-container');
        if(loader?.classList) {
            loader.classList.remove("show-overlay-loader");
            loader.classList.add("hide-loader");
        }
    }

    hideLoader(){
        this.renderer.removeClass(document.body, 'show-overlay-loader');
        this.renderer.addClass(document.body, 'hide-loader');
    }
    showLoader(){
        this.renderer.removeClass(document.body, 'hide-loader');
    }
    showOverlayLoader(){
        this.renderer.removeClass(document.body, 'hide-loader');
        this.renderer.addClass(document.body, 'show-overlay-loader');
    }
}